import Hero from "../components/Hero";
import TrustedBy from "../components/TrustedBy";
import StatsQuote from "../components/StatsQuote";
import StudentJourney from "../components/StudentJourney";
import SkillGap from "../components/SkillGap";
import Programmes from "../components/Programmes";
import Testimonials from "../components/Testimonials";
import Mentors from "../components/Mentors";
// import ReadinessQuiz from "../components/ReadinessQuiz";
import WaitlistCTA from "../components/WaitlistCTA";

export default function HomePage() {
    return (
        <main data-testid="home-page">
            <Hero />
            <TrustedBy />
            <StatsQuote />
            <Programmes />
            {/* <StudentJourney /> */}
            <SkillGap />

            {/* <Testimonials /> */}
            <Mentors />
            {/* <ReadinessQuiz /> */}
            {/* <WaitlistCTA /> */}
        </main>
    );
}
